

<template>
  <div class="select-container-box" style="display: none;">
    <span>审核状态&nbsp;&nbsp;</span>
    <el-select :value="auditStatus" size="small" @change="handleAuditStatus">
      <el-option label="全部" value="" />
      <el-option label="待审核" :value="0" />
      <el-option label="已审核" :value="1" />
    </el-select>
  </div>
</template>


<script>
export default {
  name: "AuditStatus",
  props: ['auditStatus'],
  data() {
    return {};
  },
  mounted() {},
  methods: {
    handleAuditStatus(val){
      this.$emit('update:auditStatus', val)
    }
  }
}
</script>
<style lang="stylus">
  
</style>
